import NetworkCircuit from './NetworkCircuit';

export default NetworkCircuit;
